/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * BMC Hiring Tool API
 * OpenAPI spec version: 0.1.0
 */
export interface HealthStatus {
  status: string;
}

export interface ErrorResponse {
  error: string;
}

export interface LoginBody {
  password: string;
}

export interface AuthResult {
  authenticated: boolean;
}

export type CampaignPrizePoolItem = {
  place: number;
  amount: number;
};

export type CampaignStatus =
  (typeof CampaignStatus)[keyof typeof CampaignStatus];

export const CampaignStatus = {
  draft: "draft",
  active: "active",
  paused: "paused",
  completed: "completed",
} as const;

export interface Campaign {
  id: string;
  brand_name: string;
  product_name?: string | null;
  offer_amount: number;
  num_videos_per_creator: number;
  max_spots?: number | null;
  brief_requirements?: string | null;
  tap_link?: string | null;
  rewards_campaign_link?: string | null;
  has_rewards?: boolean | null;
  is_rewards_campaign?: boolean | null;
  product_ids?: string[] | null;
  campaign_start_date?: string | null;
  campaign_end_date?: string | null;
  prize_pool?: CampaignPrizePoolItem[] | null;
  additional_info?: string | null;
  email_subject?: string | null;
  email_greeting?: string | null;
  email_headline?: string | null;
  email_cta_text?: string | null;
  email_preheader?: string | null;
  email_prizes_desc?: string | null;
  email_commission_desc?: string | null;
  accept_headline?: string | null;
  accept_cta_text?: string | null;
  accepted_title?: string | null;
  accepted_message?: string | null;
  accepted_next_steps?: string | null;
  show_bonus_note?: boolean | null;
  bonus_note_text?: string | null;
  commission_text?: string | null;
  product_image_url?: string | null;
  status: CampaignStatus;
  created_at: string;
  updated_at: string;
}

export type CampaignSummary = Campaign & {
  offers_sent: number;
  offers_accepted: number;
};

export type CampaignBodyPrizePoolItem = {
  place: number;
  amount: number;
};

export type CampaignBodyStatus =
  (typeof CampaignBodyStatus)[keyof typeof CampaignBodyStatus];

export const CampaignBodyStatus = {
  draft: "draft",
  active: "active",
  paused: "paused",
  completed: "completed",
} as const;

export interface CampaignBody {
  brand_name: string;
  product_name?: string | null;
  offer_amount: number;
  num_videos_per_creator: number;
  max_spots?: number | null;
  brief_requirements?: string | null;
  tap_link?: string | null;
  rewards_campaign_link?: string | null;
  has_rewards?: boolean | null;
  is_rewards_campaign?: boolean | null;
  product_ids?: string[] | null;
  campaign_start_date?: string | null;
  campaign_end_date?: string | null;
  prize_pool?: CampaignBodyPrizePoolItem[] | null;
  additional_info?: string | null;
  email_subject?: string | null;
  email_greeting?: string | null;
  email_headline?: string | null;
  email_cta_text?: string | null;
  email_preheader?: string | null;
  email_prizes_desc?: string | null;
  email_commission_desc?: string | null;
  accept_headline?: string | null;
  accept_cta_text?: string | null;
  accepted_title?: string | null;
  accepted_message?: string | null;
  accepted_next_steps?: string | null;
  show_bonus_note?: boolean | null;
  bonus_note_text?: string | null;
  commission_text?: string | null;
  product_image_url?: string | null;
  status?: CampaignBodyStatus;
}

export type OfferStatus = (typeof OfferStatus)[keyof typeof OfferStatus];

export const OfferStatus = {
  sent: "sent",
  accepted: "accepted",
} as const;

export interface Offer {
  id: string;
  campaign_id: string;
  creator_id: string;
  creator_name?: string | null;
  creator_email: string;
  creator_tiktok?: string | null;
  status: OfferStatus;
  acceptance_token: string;
  email_sent_at?: string | null;
  accepted_at?: string | null;
  sample_requested: boolean;
  sample_shipped: boolean;
  videos_received: number;
  notes?: string | null;
  created_at: string;
}

export type CampaignDetail = CampaignSummary & {
  offers: Offer[];
  samples_requested: number;
  samples_shipped: number;
  total_videos_received: number;
  pagination?: {
    total: number;
    page: number;
    limit: number;
    total_pages: number;
  };
};

export interface Creator {
  id: string;
  name?: string | null;
  tiktok_handle?: string | null;
  tiktok_url?: string | null;
  email?: string | null;
  phone?: string | null;
  recent_gmv: number;
  avg_gmv_per_video: number;
  total_videos: number;
  category?: string | null;
  is_active: boolean;
  last_active_date?: string | null;
  already_sent: boolean;
  is_favorite: boolean;
  is_hidden: boolean;
}

export interface CreatorSearchResult {
  creators: Creator[];
  total: number;
  page: number;
  per_page: number;
  categories: string[];
}

export interface SendOfferBody {
  creator_id: string;
  email_subject?: string | null;
  email_greeting?: string | null;
  email_headline?: string | null;
  email_cta_text?: string | null;
  email_preheader?: string | null;
  email_prizes_desc?: string | null;
  email_commission_desc?: string | null;
  show_hybrid_note?: boolean | null;
}

export interface UpdateOfferBody {
  sample_requested?: boolean;
  sample_shipped?: boolean;
  videos_received?: number;
  notes?: string | null;
}

export interface ResendResult {
  success: boolean;
  message: string;
}

export interface AcceptDetail {
  offer: Offer;
  campaign: Campaign;
}

export interface FollowUpBody {
  /** List of offer IDs to email. If empty/omitted, emails all creators in the campaign. */
  offer_ids?: string[];
  subject: string;
  body: string;
}

export type FindCreatorsParams = {
  search?: string;
  category?: string;
  gender?: string;
  minGmv?: number;
  maxGmv?: number;
  minGmvPerVideo?: number;
  maxGmvPerVideo?: number;
  minRoi?: number;
  maxRoi?: number;
  minRate?: number;
  maxRate?: number;
  activeOnly?: boolean;
  showFavoritesOnly?: boolean;
  showHidden?: boolean;
  sortBy?: FindCreatorsSortBy;
  page?: number;
};

export type FindCreatorsSortBy =
  (typeof FindCreatorsSortBy)[keyof typeof FindCreatorsSortBy];

export const FindCreatorsSortBy = {
  gmv_desc: "gmv_desc",
  gmv_per_video_desc: "gmv_per_video_desc",
  roi_desc: "roi_desc",
  name_asc: "name_asc",
} as const;

export type SetCreatorPreferenceBody = {
  is_favorite: boolean;
  is_hidden: boolean;
};

export type SetCreatorPreference200 = {
  is_favorite: boolean;
  is_hidden: boolean;
};

export type SendFollowUp200 = {
  sent: number;
  failed: number;
};

export interface BulkSendOffersBody {
  creator_ids: string[];
  email_subject?: string | null;
  email_greeting?: string | null;
  email_headline?: string | null;
  email_cta_text?: string | null;
  email_preheader?: string | null;
  email_prizes_desc?: string | null;
  email_commission_desc?: string | null;
}

export type BulkSendOffersResult = {
  sent: { id: string; campaign_id: string; creator_id: string; [key: string]: unknown }[];
  failed: { creator_id: string; error: string }[];
  skipped: { creator_id: string; reason: string }[];
  emailFailed: { id: string; creator_id: string; _message: string; _emailError: string }[];
};
